export const FILTER_RESET = '@@search/FILTER_RESET';
export const FILTER_UPDATE = '@@search/FILTER_UPDATE';

export const ANNOUNCEMENT_LOAD = '@@search/ANNOUNCEMENT_LOAD';
export const ANNOUNCEMENT_COUNT_LOAD = '@@search/ANNOUNCEMENT_COUNT_LOAD';

export const SEARCH_FILTER = '@@search/SEARCH_FILTER'; // сохраненные поиски
export const SUBSCRIPTION = '@@search/SUBSCRIPTION_SEARCH_FILTER'; // подписаться на новые

export const AGENCIES_LOAD = '@@search/AGENCIES_LOAD';

export const AUTOCOMPLETE_UPDATE = '@@search/AUTOCOMPLETE_UPDATE';



// WEBPACK FOOTER //
// ./src/app/Search/actionTypes.js